// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attached-links .links .link + .link {\n  margin-top: 12px;\n}", "",{"version":3,"sources":["webpack://src/components/AttachedLinks/index.scss"],"names":[],"mappings":"AAEI;EACE,gBAAA;AADN","sourcesContent":[".attached-links {\n  .links {\n    .link + .link {\n      margin-top: 12px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
